import {MARK_UPDATE, MARK_CLEAN, GET_MARK_TAG} from '../actions/ActionTypes';

const initialState = {
    curStep: 1,
    phone: '',
    phoneErr: '',
    phoneName: '',
    markType: '',
    markTypeErr: '',
    markTag: {},
    contactPhone: '',
    contactPhoneErr: '',
    phoneCode: '',
    phoneCodeErr: '',
    contactTime: undefined,
    contactTimeErr: '',
    harassType: undefined,
    harassTypeErr: '',
    desc: '',
    descErr: '',
    callDate: '',
    callDateErr: ''
};
export function markReducer(state = initialState, action) {
    switch (action.type) {
        case GET_MARK_TAG:
            return {
                ...state,
                markTag: action.data
            };
        case MARK_UPDATE:
            return {
                ...state,
                ...action.data
            };
        case MARK_CLEAN:
            return {
                ...initialState
            };
        default:
            return state;
    }
}
